export const ADD_APP_DATA = 'ADD_APP_DATA'
export const ADD_APP_APPEARANCE = 'ADD_APP_APPEARANCE'
export const ADD_APP_DETAILS = 'ADD_APP_DETAILS'
export const INITIAL_STATE = 'INITIAL_STATE'
export const ADD_APP_ONBOARDING_DATA = 'ADD_APP_ONBOARDING_DATA'
export const ADD_FDC3_INTEROP_DRAFT = 'ADD_FDC3_INTEROP_DRAFT'
